<ph-facts size="small" value-align="end" [heading]="section.label || ''" [attr.items]="section.items | json"></ph-facts>
